<script lang="ts">
    import Fa from 'svelte-fa'
    import { faEdit, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons'
    import Popover from '../_common/popover.svelte'
    import { onMount } from 'svelte'
    import { Audience } from '../../modules/eventsApi/audiences/audience'
    import { AudiencesRepository } from '../../modules/eventsApi/audiences/audiences.repository'
    import { AudiencesService } from '../../modules/eventsApi/audiences/audiences.service'
    import AudienceManager from '../automacao/audience/audience-manager.svelte'

    export let audience: Audience = null
    export let disabled: boolean = false
    export let small = false
    export let label = ''

    const serviceR = new AudiencesRepository()
    const servicesS = new AudiencesService(serviceR)
    let query = ''
    let audiences: Audience[] = []

    let delay = null
    async function search(query) {
        if (delay) clearInterval(delay)
        delay = setTimeout(async () => {
            audiences = await servicesS.getAll({ query, pageSize: 100, type: 'static' })
            if (audiences.length === 0) dropHelper = 'Não encontrado.'
        }, 500)
    }
    async function getFirst100() {
        audiences = await servicesS.getAll({ pageSize: 100 })
    }

    function select(index) {
        audience = audiences[index]
        query = ''
        audiences = []
    }

    async function loadAudience(audienceId) {
        if (audienceId) {
            audience = await servicesS.getOne(audienceId)
            _showDrop = false
        }
    }

    function friendlyName(p) {
        return p.title
    }

    function clear() {
        audience = null
        _showDrop = false
    }

    function newAudience() {
        audience = new Audience()
        showForm = true
    }

    function editAudience() {
        showForm = true
    }

    let showForm = false
    async function hideForm(event) {
        showForm = false
        if (event.detail?.audienceId) {
            audience = event.detail
        }
        await getFirst100()
    }

    let _showDrop = false
    let dropHelper = 'Digite ao menos 3 caracteres para pesquisar...'
    function showDrop(event) {
        _showDrop = true
    }

    function hideDrop(event) {
        console.log('event', event)
        setTimeout(() => {
            _showDrop = false
        }, 300)
    }

    onMount(async () => {
        await getFirst100()
    })

    $: {
        if (audience?.audienceId && !audience?.createdAt) loadAudience(audience.audienceId)
        search(query)
    }
</script>

{#if showForm}
    <Popover on:close={hideForm} title="Serviço" height="420px" width="970px">
        <AudienceManager form={true} audienceId={audience.audienceId} type="static" on:close={hideForm} />
    </Popover>
{/if}
<div class="query">
    <div class="input-group" class:input-group-sm={small === true}>
        {#if label}
            <div class="input-group-text">{label}</div>
        {/if}
        {#if audience && audience.audienceId}
            <input
                class="form-control"
                class:form-control-sm={small === true}
                disabled
                value={friendlyName(audience)}
                type="text"
            />
            <!-- <button on:click={editAudience} class="btn btn-secondary"><Fa icon={faEdit} /></button> -->
            {#if !disabled}
                <button class="btn btn-secondary" class:form-control-sm={small === true} on:click={clear}
                    ><Fa icon={faTimes} /></button
                >
            {/if}
        {:else}
            <input
                class="form-control select-icon"
                class:form-control-sm={small === true}
                type="text"
                bind:value={query}
                on:focus={showDrop}
                on:blur={hideDrop}
            />
            <button on:click={newAudience} class="btn btn-secondary"><Fa icon={faPlus} /></button>
        {/if}
    </div>

    {#if _showDrop}
        <div class="list scroll-dark">
            {#if audiences.length === 0}
                <div class="list-helper p-2 text-muted">{dropHelper}</div>
            {:else}
                {#each audiences as p, index}
                    <button
                        on:click={() => {
                            select(index)
                        }}>{friendlyName(p)}</button
                    >
                {/each}
            {/if}
        </div>
    {/if}
</div>

<style>
    .list-helper {
        color: #333;
        background-color: #eee;
    }
    .query {
        position: relative;
        flex-grow: 1;
        width: 100%;
    }
    .list {
        display: flex;
        flex-direction: column;
        box-shadow: 4px 3px 6px #111;
        position: absolute;
        flex-grow: 1;
        z-index: 5;
        width: 100%;
        overflow-y: auto;
        max-height: 200px;
    }
    .list button {
        flex-grow: 1;
        padding: 8px;
        text-align: left;
    }
    .list button:hover {
        background-color: #ddd;
    }
</style>
